import moment from "moment";

import { dateFormat } from "shared/constants/dataManagement";

const DateCell = (value: number) => (
  <span>{value ? moment(value).format(`${dateFormat} hh:mm:ss a`) : ""}</span>
);

export default DateCell;
